import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { environment } from '@environments/environment';
import { ServiceRequestTypeEnum } from '@enums/service-request-type.enum';
import { CustomerProfileServiceOptionsInterface } from '../pages/customer-profile/service-options/interfaces/customer-profile-service-options.interface';

/**
 * Shared HTTP client for customer onboarding APIs used across multiple steps.
 */
@Injectable()
export class CustomerOnboardingHttpService {
  private readonly httpClient = inject(HttpClient);

  /**
   * Retrieves selected service request types for the customer.
   *
   * @param customerId - ID of the customer whose selected SR types are fetched
   */
  getCustomerSRTypes(customerId: string): Observable<ServiceRequestTypeEnum[]> {
    const url = `${environment.apiHostV2}/customer-config/profile/service-options?customerId=${customerId}`;

    return this.httpClient.get<CustomerProfileServiceOptionsInterface>(url).pipe(
      map((response: CustomerProfileServiceOptionsInterface): ServiceRequestTypeEnum[] => response.selectedSrTypes ?? []),
      catchError((error: HttpErrorResponse) => throwError(() => error)),
    );
  }
}
